import { get } from './get';
import { pageContext } from './page_context';

/**
 * Extracts 0, 1 or more properties out of the props argument.
 * The properties to extract are defined via the keys argument.
 * If properties are extracted the returned object is a hybrid between both arguments.
 * Example:
 * extractProps({ key: 'value' }, { newKey: 'key' })
 * > { newKey: 'value' }
 * @param {Object} props - Object to extract properties from.
 * @param {Object|string|string[]} keys - Keys of the properties to extract.
 * @returns {Object} A hybrid Object containing the properties found with keys from keys argument.
 */
export const extractProps = (props, keys) => {
    const extractedProps = {};
    for (const extractedKey of Object.keys(keys)) {
        const propKey = keys[extractedKey];
        extractedProps[extractedKey] = get(props, propKey);
    }
    return extractedProps;
};

/**
 * Deprecation warning for using shaped props in Components
 * @param {Object} props - Object to extract properties from
 * @param {String} componentName - Name of the component that throws the warning
 */
export const shapedPropsWarning = (props, componentName) => {
    if (pageContext.inDevMode()) {
        // @TODO: eventually we should get rid of stateProps and dataProps too, they are mostly used in sidebar and results components
        const { visualProps, elementProps, contentProps, eventProps /* , dataProps, stateProps */ } = props;
        if (visualProps || elementProps || contentProps || eventProps /* || dataProps || stateProps */) {
            // eslint-disable-next-line no-console
            console.error(
                `[WARNING] (${componentName}) Shaped props such as "visualProps" or "elementProps" are deprecated 
                in this component, please spread the shaped props`, props
            );
        }
    }
};
